export default __webpack_public_path__ + "static/elpais-97abc45bbd9bc7d3b623692655bab96b.png";